import React from 'react';
import { SupplierReview } from '@/shared/types/catalog';
import SupplierReviews from '../../Common/SupplierReviews';
import { SupplierReviewSummaryResponse } from '@/shared/types/api/catalog';

interface IProps {
  reviewsList: SupplierReview[];
  reviewSummary: SupplierReviewSummaryResponse;
  total: number;
  page: number;
  supplierName: string;
}

const ReviewsTab = ({ reviewsList, reviewSummary, total, page, supplierName }: IProps) => {
  return (
    <div className="supplier-review-box">
      <SupplierReviews
        reviewsList={reviewsList}
        reviewSummary={reviewSummary}
        total={total}
        page={page}
        supplierName={supplierName}
      />
    </div>
  );
};

export default ReviewsTab;
